import type { ITypographyType } from "./types";

export const typographies: ITypographyType = {
  h1: {
    color: "primary-text",
    fontSize: "7xl",
    fontWeight: "bold",
    fontFamily: "Morabba",
    tag: "h1",
  },
  h2: {
    color: "primary-text",
    fontSize: "2xl",
    fontWeight: "bold",
    fontFamily: "Morabba",
    tag: "h2",
  },
  h3: {
    color: "primary-text",
    fontSize: "xl",
    fontWeight: "bold",
    fontFamily: "Morabba",
    tag: "h3",
  },
  h4: {
    color: "primary-text",
    fontSize: "lg",
    fontWeight: "bold",
    fontFamily: "Morabba",
    tag: "h4",
  },
  h5: {
    color: "primary-text",
    fontSize: "base",
    fontWeight: "bold",
    fontFamily: "Morabba",
    tag: "h5",
  },
  h6: {
    color: "primary-text",
    fontSize: "md-high",
    fontWeight: "bold",
    fontFamily: "Morabba",
    tag: "h6",
  },
  badge: {
    color: "secondary-text-light",
    fontSize: "micro",
    fontWeight: "medium",
    tag: "span",
  },
  body: {
    color: "primary-text",
    fontSize: "md",
    fontWeight: "inherit",
    tag: "p",
  },
  caption1: {
    color: "secondary-text",
    fontSize: "sm",
    fontWeight: "medium",
    tag: "p",
  },
  caption2: {
    color: "secondary-text",
    fontSize: "xs",
    fontWeight: "medium",
    tag: "p",
  },
  caption3: {
    color: "secondary-text",
    fontSize: "md",
    fontWeight: "medium",
    tag: "p",
  },
  regularCaption: {
    color: "secondary-text",
    fontSize: "md",
    fontWeight: "regular",
    tag: "p",
  },
  description1: {
    color: "secondary-text",
    fontSize: "md-high",
    fontWeight: "medium",
    tag: "p",
  },
  description2: {
    color: "primary-text",
    fontSize: "md-high",
    fontWeight: "regular",
    tag: "p",
  },
  inherit: {
    color: "inherit",
    fontSize: "inherit",
    fontWeight: "inherit",
    tag: "span",
  },
  formSectionHeader: {
    color: "secondary-text",
    fontSize: "base",
    fontWeight: "medium",
    tag: "p",
    fontFamily: "Morabba",
  },
  subtitle1: {
    color: "primary-text",
    fontWeight: "semi-bold",
    fontSize: "md",
    tag: "p",
  },
  subtitle2: {
    color: "primary-text",
    fontWeight: "semi-bold",
    fontSize: "sm",
    tag: "p",
  },
  subtitle3: {
    color: "primary-text",
    fontWeight: "semi-bold",
    fontSize: "xs",
    tag: "p",
  },
  "appointment-status": {
    color: "white",
    fontSize: "xs",
    fontWeight: "semi-bold",
    tag: "span",
  },
};
